import Chart from 'chart.js'

/* Based off of: http://jsfiddle.net/nkzyx50o/ */
Chart.defaults.global.defaultFontFamily = "'DIN', 'Helvetica Neue', Helvetica, Arial";
Chart.defaults.global.defaultFontColor = '#ffffff';
Chart.defaults.global.title.fontSize = 24;
Chart.defaults.global.title.fontColor = '#ffffff';
Chart.defaults.global.title.padding = 16;
Chart.defaults.global.layout.padding.bottom = 16;
Chart.defaults.global.layout.backgroundColor = "#333941";

Chart.plugins.register({
	id: 'ChartBackgroundColor',
	beforeDraw: function(chartInstance) {
		var ctx = chartInstance.chart.ctx;
		ctx.fillStyle = Chart.defaults.global.layout.backgroundColor;
		ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
	}
});

Chart.pluginService.register({
	id: 'PieChartCustomHover',
	beforeDraw: function (chart) {
		//if (chart.id!=chartId) return;
		if (chart.config.options.elements.customHover) {

			//Get ctx from string
			var ctx = chart.chart.ctx;

			var beforeHoverText = chart.config.options.elements.customHover.beforeHoverText || '';
			var chartUnit = chart.config.options.elements.customHover.chartUnit || '';
			//var centerConfig = chart.config.options.elements.center;
			var fontFamily = Chart.defaults.global.defaultFontFamily;
			ctx.fontWeight = '300';
			ctx.fillStyle = Chart.defaults.global.defaultFontColor;

			//Set font settings to draw it correctly.
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
			var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);

			var lastActive = chart.lastActive[0];
			if (typeof lastActive === 'undefined') {
				if (typeof beforeHoverText !== 'undefined') {
					var labelFontSize = (beforeHoverText==='true') ? '40px' : '12px';
					ctx.font = labelFontSize + " " + fontFamily;
					ctx.fillText(beforeHoverText, centerX, centerY);
				}
				return;
			}

			var currDataset = chart.chart.getDatasetMeta(lastActive._datasetIndex);
			var currLabel = currDataset.data[lastActive._index]._model.label;
			var currValue = chart.chart.data.datasets[0].data[lastActive._index];

			ctx.font = "46px " + fontFamily;
			ctx.fillText(currValue, centerX, centerY);

			ctx.font = "12px " + fontFamily;
			ctx.fillText(currLabel, centerX, centerY - 35);
			ctx.fillText(chartUnit, centerX, centerY + 35);
			return;

		}
	}
});